/** Move only the sidebar; preserve group order and respect reduced motion. */
export function revealNavigationSection(container, group) {
    if (!container || !group) return
    const viewport = container.getBoundingClientRect()
    const heading = group.getBoundingClientRect()
    const links = [...group.querySelectorAll('.nav-link')].slice(0, 3)
    const bottom = links.at(-1)?.getBoundingClientRect().bottom ?? heading.bottom
    const top = viewport.top + 8
    const end = viewport.bottom - 8
    let delta = 0
    if (heading.top < top || (bottom > end && bottom - heading.top > end - top)) delta = heading.top - top
    else if (bottom > end) delta = bottom - end
    if (Math.abs(delta) < 1) return
    container.scrollBy({ top: delta, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' })
}
